import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['item']
  connect() {
    this._highlightedClass = this.data.get('highlight-class')
    this._highligtedItem = null

    this.itemTargets.some((item) => {
      if (item.classList.contains(this._highlightedClass)) {
        this._highlightedItem = item
        return true
      }
    })
  }

  highlightItem(event) {
    const item = this.getItemToHighlight(event.currentTarget)
    if (item && !item.classList.contains(this._highlightedClass)) {
      item.classList.add(this._highlightedClass)
      if (this._highlightedItem) {
        this._highlightedItem.classList.remove(this._highlightedClass)
      }
      this._highlightedItem = item
    }
  }

  getItemToHighlight(element) {
    let item = null
    if (this.isAnItem(element)) {
      item = element
    } else {
      const possibleItems = element.querySelectorAll('[data-target]')
      for (let index = 0; index < possibleItems.length; index++) {
        if (this.isAnItem(possibleItems[index])) {
          item = possibleItems[index]
          break
        }
      }
    }
    return item
  }

  isAnItem(element) {
    return new Set((element.dataset.target || '').split(' ') || []).has('highlighter.item')
  }
}
